import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import message from 'ant-design-vue/lib/message';
import { ref,reactive } from 'vue';
import { ossToken } from '@/api/user';
import OSS from 'ali-oss';


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFile',
  props: {
    bnTitle: {
        type: String,
        default: "上颌"
    },
    fileName: {
        type: String,
        default: "L.stl"
    },
    accept: {
        type: String,
        default: "image/png, image/jpeg"
    },
    path: {
        type: String,
        default: ""
    }
},
  emits: ['onSuccess'],
  setup(__props, { emit: emits }) {

const props = __props;

const data = reactive({
    fileName:''
})





const beforeUpload = async (file: any) => {
    ossToken().then(async (sts: any) => {
        console.log(sts);
        const client = new OSS({
            region: sts.region,
            accessKeyId: sts.accessKey,
            accessKeySecret: sts.accessSecret,
            stsToken: sts.token,
            bucket: sts.bucket,
            secure: true,
            endpoint: sts.endpoint,
        })
        const ali = await client.multipartUpload(props.path, file, { headers: { "Access-Control-Allow-Origin": "*" }, });
        console.log(ali);        
        if (ali.res.status === 200) {
            data.fileName = props.fileName
            message.info(`${file.name}上传成功，路径为: ${ali.name}`)
            emits('onSuccess', ali.name);
        } else {
            message.error(`${file.name}上传失败`)
        }
    })
    return false;
};

const fileList = ref([]);


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_upload, {
      "show-upload-list": false,
      accept: props.accept,
      "file-list": fileList.value,
      "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
      name: "file",
      "before-upload": beforeUpload
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.bnTitle), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_input, {
              disabled: "",
              value: data.fileName
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["accept", "file-list"])
  ]))
}
}

})